function getID(date: Date) {
  const minify = Math.floor(date.getTime() / 1000) - 1659488984;
  const base36 = minify.toString(36);
  const randomNumber = Math.floor(Math.random() * 10).toString();
  const finalID = (base36 + randomNumber).toUpperCase();
  return finalID;
}
export default getID;
